import Vue from 'vue';
const toast = new Vue();

class ToastCls {
    public error(message: string, error?: any) {
        toast.$emit('error', message, error);
    }
    public warning(message: string, error?: any) {
        toast.$emit('warning', message, error);
    }
    public success(message: string, error?: any) {
        toast.$emit('success', message, error);
    }
    public info(message: string, error?: any) {
        toast.$emit('info', message, error);
    }
}

Vue.use({
    install(vue) {
        vue.prototype.$toast = toast;

        vue.prototype.$toast.error = (message: string, error?: any) => toast.$emit('error', message, error);

        vue.prototype.$toast.warning = (message: string, error?: any) => toast.$emit('warning', message, error);

        vue.prototype.$toast.success = (message: string, error?: any) => toast.$emit('success', message, error);

        vue.prototype.$toast.info = (message: string, error?: any) => toast.$emit('info', message, error);
    }
});

export const Toast = new ToastCls();
